const pixelsCategories = ["PERFORMANCE","SOCIAL","TARGETING"];

export { pixelsCategories };